import { create } from 'zustand';
import { adultShowAdModeSafeLocalStorage } from '../lib/storage/storageImplementations';

interface PartnerState {
  AdultShowAdMode: 'on' | 'off';
  isShowAdultMedia: boolean;
  setAdultShowAdMode: (payload: 'on' | 'off') => void;
  setShowAdultMedia: () => void;
}

const partner = create<PartnerState>()((set) => ({
  AdultShowAdMode: adultShowAdModeSafeLocalStorage.get() || 'off',
  setAdultShowAdMode: (payload: 'on' | 'off') => {
    adultShowAdModeSafeLocalStorage.set(payload);
    set(() => ({ AdultShowAdMode: payload }));
  },
  isShowAdultMedia: false,
  setShowAdultMedia: () => set((state) => ({ isShowAdultMedia: !state.isShowAdultMedia })),
}));

export default partner;
